import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IcmPaginacaoTabelaModule } from '@inovamobil/icm-paginacao-tabela';
import { IcmPesquisaTabelaModule } from '@inovamobil/icm-pesquisa-tabela';
import { IcmRodapeTabelaSelecaoModule } from '@inovamobil/icm-rodape-tabela-selecao';
import { IcmMenuTabelaSelecaoModule } from '@inovamobil/icm-tabelas';
import { NgxMaskModule } from 'ngx-mask';

import { IcmColunaBotaoComponent } from './colunas-customizadas/icm-coluna-botao/icm-coluna-botao.component';
import { IcmColunaBotoesComponent } from './colunas-customizadas/icm-coluna-botoes/icm-coluna-botoes.component';
import { IcmColunaCheckboxComponent } from './colunas-customizadas/icm-coluna-checkbox/icm-coluna-checkbox.component';
import { IcmColunaDataComponent } from './colunas-customizadas/icm-coluna-data/icm-coluna-data.component';
import { IcmColunaIconeComponent } from './colunas-customizadas/icm-coluna-icone/icm-coluna-icone.component';
import { IcmColunaMascaraComponent } from './colunas-customizadas/icm-coluna-mascara/icm-coluna-mascara.component';
import { IcmColunaMonetarioComponent } from './colunas-customizadas/icm-coluna-monetario/icm-coluna-monetario.component';
import { IcmColunaStatusComponent } from './colunas-customizadas/icm-coluna-status/icm-coluna-status.component';
import { IcmColunaTextoBotoesComponent } from './colunas-customizadas/icm-coluna-texto-botoes/icm-coluna-texto-botoes.component';
import { IcmColunaTextoIconeComponent } from './colunas-customizadas/icm-coluna-texto-icone/icm-coluna-texto-icone.component';
import { IcmColunaTextoComponent } from './colunas-customizadas/icm-coluna-texto/icm-coluna-texto.component';
import { IcmColunaValorComponent } from './colunas-customizadas/icm-coluna-valor/icm-coluna-valor.component';
import { IcmDatatableComponent } from './icm-data-table.component';

registerLocaleData(localePt);
@NgModule({
    declarations: [
        IcmDatatableComponent,
        IcmColunaTextoIconeComponent,
        IcmColunaTextoComponent,
        IcmColunaValorComponent,
        IcmColunaMonetarioComponent,
        IcmColunaDataComponent,
        IcmColunaIconeComponent,
        IcmColunaBotoesComponent,
        IcmColunaBotaoComponent,
        IcmColunaCheckboxComponent,
        IcmColunaStatusComponent,
        IcmColunaTextoBotoesComponent,
        IcmColunaMascaraComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,

        IcmPesquisaTabelaModule,
        IcmPaginacaoTabelaModule,
        IcmRodapeTabelaSelecaoModule,
        IcmMenuTabelaSelecaoModule,

        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressBarModule,
        MatRadioModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        NgxMaskModule.forRoot(),
    ],
    exports: [
        IcmDatatableComponent,
        IcmColunaTextoIconeComponent,
        IcmColunaTextoComponent,
        IcmColunaValorComponent,
        IcmColunaMonetarioComponent,
        IcmColunaDataComponent,
        IcmColunaIconeComponent,
        IcmColunaBotoesComponent,
        IcmColunaBotaoComponent,
        IcmColunaCheckboxComponent,
        IcmColunaStatusComponent,
        IcmColunaTextoBotoesComponent,
        IcmColunaMascaraComponent,
    ],
    providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }],
})
export class IcmDatatableModule {}
